import { useSelector } from "react-redux";
import InputSinNumber from "../../../../components/input/InputSinNumber";

import ColOpcion from "./ColOpcion";
import ColTitulo from "./ColTitulo";
import RowCosto from "./RowCosto";

export default function CostoTiempoMaquinaImpDigital() {
  const {
   costoTiempoMaquinaImpDigitalOpcion1,
    costoTiempoMaquinaImpDigitalOpcion2,
    costoTiempoMaquinaImpDigitalOpcion3,
    costoTiempoMaquinaImpDigitalOpcion4,
    costoTiempoMaquinaImpDigitalOpcion5,
  } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  
  return (
    <RowCosto>
      <ColTitulo>Costo tiempo máquina IMPRESIÓN DIGITAL</ColTitulo>
      <ColOpcion>
        <InputSinNumber value={costoTiempoMaquinaImpDigitalOpcion1} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={costoTiempoMaquinaImpDigitalOpcion2} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={costoTiempoMaquinaImpDigitalOpcion3} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={costoTiempoMaquinaImpDigitalOpcion4} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={costoTiempoMaquinaImpDigitalOpcion5} disabled />
      </ColOpcion>
    </RowCosto>
  );
}
